import { render, staticRenderFns } from "./RightInfo.vue?vue&type=template&id=157f3e54&scoped=true"
import script from "./RightInfo.vue?vue&type=script&lang=js"
export * from "./RightInfo.vue?vue&type=script&lang=js"
import style0 from "./RightInfo.vue?vue&type=style&index=0&id=157f3e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f3e54",
  null
  
)

export default component.exports